import { render, staticRenderFns } from "./KoioteDraggableResizable.vue?vue&type=template&id=f8d3a9c6&scoped=true&"
import script from "./KoioteDraggableResizable.vue?vue&type=script&lang=js&"
export * from "./KoioteDraggableResizable.vue?vue&type=script&lang=js&"
import style0 from "./KoioteDraggableResizable.vue?vue&type=style&index=0&id=f8d3a9c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d3a9c6",
  null
  
)

export default component.exports